<a id="btnDownload" class="d-none" href="javascript:void('');" download>DownloadFakeBtn</a>
<div class="page">
    <div class="page_header">
        <h1 class="page_title">{{'management' | translate}} | <span>Gerenciar trocas</span></h1>
        <div class="page_action" style="gap: 20px">
            <a href="javascript:void(0)" (click)="actionExcel()" *ngIf="buttonExcel"
                class="page_action_excel mr-2 btn btn-gray-fill" type="button">
                <svg-icon src="assets/svg/download.svg"></svg-icon>
                <span class="font-weight-normal">Exportar Excel</span>
            </a>
        </div>
    </div>
    <div class="page_padding">
        <div class="page_filter mb-4">
            <div class="input-material mr-auto" style="max-width: 394px">
                <input id="search" class="form-control" type="text" required [(ngModel)]="searchBuyMovInput.re" />
                <label for="search">
                    <svg-icon src="assets/svg/search.svg"></svg-icon>
                    Buscar pelo RE
                </label>

            </div>
            <div class="d-flex align-items-center flex-wrap mb-5" style="gap: 17px">
                <div class="input-material flex-grow-1">
                    <ng-multiselect-dropdown [settings]="dropSettings" [(ngModel)]="listStatusItems"
                        [data]="listStatusDrop" [placeholder]="'buscar' | translate">
                    </ng-multiselect-dropdown>
                    <label class="mb-0 mr-3 disabled">Status</label>
                </div>
            </div>
            <div class="input-material">
                <input id="start" class="form-control picker-period" type="text" required />
                <label for="start">
                    {{'minhalista.periodo' | translate}}
                </label>
                <svg-icon [svgClass]="'position-absolute date'" src="assets/svg/date.svg"></svg-icon>
            </div>
            <div class="page_filter_action flex-grow-1" style="max-width: 500px;">
                <a href="javascript:void(0)" (click)="onSearch()" class="btn btn-block btn-lg btn-primary btn-search"
                    style="font-weight: normal;" type="button">Buscar</a>
            </div>
        </div>
        <div class="page_order">
            <div class="page_order_line">&nbsp;</div>
            <div class="page_order_box">
                <span class="page_order_lbl">Ordenar</span>
                <select [(ngModel)]="sortOption" (ngModelChange)="applySort()" class="page_order_select">
                    <option value="date_desc">Data (mais recentes)</option>
                    <option value="date_asc">Data (mais antigas)</option>
                    <option value="status_asc">Status (A–Z)</option>
                </select>
            </div>
        </div>
        <div class="table-responsive">
            <table class="table table_regular">
                <thead>
                    <tr>
                        <th class="w-15" scope="col"></th>
                        <th scope="col">Nome</th>
                        <th scope="col">E-mail</th>
                        <th scope="col">Telefone</th>
                        <th scope="col">RE</th>
                        <th scope="col">Data da compra</th>
                        <th scope="col">Valor da compra</th>
                        <th scope="col">Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let buy of buys">
                        <td>
                            <div class="actions-list">
                                <button (click)="onViewDetails(buy)">
                                     <p>Ver detalhes</p>
                                </button>
                            </div>
                        </td>
                        <td>{{buy?.employee?.name}}</td>
                        <td>{{buy?.employee?.email}}</td>
                        <td >{{buy?.phoneDelivery}}</td>
                        <td>{{buy?.employee?.re}}</td>
                        <td>{{buy.buyDate | date: 'dd/MM/yyyy'}}</td>
                        <td>{{buy?.valuePoint}} pontos</td>
                        <td>
                            <ng-container *ngIf="buy?.status === 'Pending'">Pendente</ng-container>
                            <ng-container *ngIf="buy?.status === 'Completed'">Entregue</ng-container>
                            <ng-container *ngIf="buy?.status === 'Canceled'">Cancelado</ng-container>
                            <ng-container *ngIf="buy?.status === 'Cancellation request'">Solicitação de Cancelamento</ng-container>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<div class="modal-custom modal fade" id="modalDetails" data-keyboard="false" data-backdrop="static" role="dialog"
    aria-labelledby="modalNoteResumeLabel" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">
        <div class="modal-content p-0">
            <div class="modal-header align-items-center bg-gray" style="min-height: 107px;">
                <h2 class="modal-title">Detalhes da compra</h2>
                <a data-dismiss="modal" class="modal_close" aria-label="Close">
                    <svg-icon src="assets/svg/close-modal.svg"></svg-icon>
                </a>
            </div>
            <div class="modal-body p-3 p-md-4">
                <div class="details-container">
                    <p>Nome do comprador: <span>{{itemOfViewDetails?.employee?.name}}</span></p>
                    <p>E-mail do comprador: <span>{{itemOfViewDetails?.employee?.email}}</span></p>
                    <p>RE do comprador: <span>{{itemOfViewDetails?.employee?.re}}</span></p>
                    <p>Telefone do comprador: <span>{{itemOfViewDetails?.phoneDelivery}}</span></p>
                    <p>Data da compra: <span>{{itemOfViewDetails?.buyDate | date: 'dd/MM/yyyy'}}</span></p>
                    <p>Status: <span [ngClass]="getStatusClass(itemOfViewDetails?.status)">{{translateStatus(itemOfViewDetails?.status)}}</span></p>

                    <div class="divider"></div>
                               
                    <div *ngFor="let item of itemOfViewDetails?.buyItems" class="item-detail">
                        <p>Nome do produto: <span>{{item?.award.name}}</span></p>
                        <p>Valor da compra: <span>{{item?.value}} pontos</span></p>
                        <p>Quantidade: <span>{{item?.quantity}}</span></p>
                        <p>Categoria: <span>{{item?.award?.category}}</span></p> 
                        <div class="divider"></div>
                </div>
                <div class="d-flex flex-grow-1" style="gap: 30px;max-width: 394px;margin: 0 auto">
                    <a class="btn flex-grow-1 btn-primary" (click)="onDischarge(itemOfViewDetails?.id)">Dar baixa</a>
                    <a class="btn flex-grow-1 btn-danger" (click)="onRemoveBuyMov(itemOfViewDetails?.id)">Cancelar Compra</a>
                    <a class="btn flex-grow-1 btn-outline-primary" data-dismiss="modal" aria-label="Close">Sair</a>

                </div>
            </div>
        </div>
    </div>
</div>